/* unplugin-vue-components disabled */import { render } from "./pySelect.vue?vue&type=template&id=d97fed36"
import script from "./pySelect.vue?vue&type=script&lang=js"
export * from "./pySelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__